import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { useLanguage } from '../../Services/LanguageContext';

interface IProps {
    query: string;
    setQuery: (value: string) => void;
}

const SearchIcon = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ color: 'var(--text-muted)' }}
    >
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
);

const FilterMechanicList: React.FC<IProps> = ({ query, setQuery }) => {
    const { t } = useLanguage();
    return (
        <div style={{ marginBottom: '24px' }}>
            <TextField
                placeholder={t('search') + '...'}
                variant='outlined'
                value={query}
                onChange={(x) => setQuery(x.target.value)}
                fullWidth
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                }}
                sx={{
                    width: '100%',
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        background: 'var(--bg-secondary)',
                        transition: 'all 0.3s ease',
                        '& fieldset': {
                            borderColor: 'var(--border-color)',
                        },
                        '&:hover fieldset': {
                            borderColor: 'var(--accent-cyan)',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: 'var(--accent-cyan)',
                            boxShadow: '0 0 15px rgba(0, 217, 255, 0.2)',
                        },
                    },
                    '& .MuiOutlinedInput-input': {
                        color: 'var(--text-primary)',
                        padding: '14px 16px',
                        '&::placeholder': {
                            color: 'var(--text-muted)',
                            opacity: 1,
                        },
                    },
                }}
            />
        </div>
    );
};

export default FilterMechanicList;
